interface IconProps {
  color?: string
  className?: string
}

export default function HomeTabIcon({ color, className }: IconProps) {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.68359 3.17188C7.73828 3.11719 7.82031 3.08984 7.90234 3.08984C7.95703 3.08984 8.03906 3.11719 8.09375 3.17188L13.1523 7.30078V11.7852C13.1523 12.0312 12.9336 12.2227 12.7148 12.2227H9.625C9.40625 12.2227 9.1875 12.0312 9.1875 11.7852V9.16016C9.1875 8.94141 8.99609 8.72266 8.75 8.72266H7C6.78125 8.72266 6.5625 8.94141 6.5625 9.16016V11.7852C6.5625 12.0312 6.37109 12.2227 6.15234 12.2227H3.08984C2.84375 12.2227 2.65234 12.0312 2.65234 11.7852V7.32812L7.68359 3.17188ZM15.6406 5.98828C15.7227 6.04297 15.7773 6.15234 15.7773 6.23438C15.7773 6.31641 15.75 6.39844 15.6953 6.45312L14.9844 7.30078C14.9297 7.38281 14.8477 7.41016 14.7383 7.41016C14.6562 7.41016 14.5742 7.38281 14.5195 7.32812L8.09375 2.05078C8.03906 1.99609 7.95703 1.96875 7.90234 1.96875C7.82031 1.96875 7.73828 1.99609 7.68359 2.05078L1.25781 7.32812C1.20312 7.38281 1.12109 7.41016 1.03906 7.41016C0.929688 7.41016 0.847656 7.38281 0.792969 7.30078L0.0820312 6.45312C0.0546875 6.39844 0 6.31641 0 6.23438C0 6.15234 0.0546875 6.04297 0.136719 5.98828L7.05469 0.273438C7.27344 0.109375 7.57422 0 7.90234 0C8.20312 0 8.50391 0.109375 8.72266 0.273438L11.1836 2.29688V0.328125C11.1836 0.136719 11.3203 0 11.5117 0H13.043C13.207 0 13.3711 0.136719 13.3711 0.328125V4.10156L15.6406 5.98828Z"
        fill={color ?? '#ffffff'}
      />
    </svg>
  )
}
